// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCake = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M13 6h4V4h2v2h3l1 1v2.667c0 .927-.387 1.742-1 2.333v8H2v-8a3.22 3.22 0 01-1-2.333V7l1-1h3V4h2v2h4V4h2zm6.5 5c.895 0 1.5-.66 1.5-1.333V8H3v1.667C3 10.339 3.605 11 4.5 11S6 10.34 6 9.667h2C8 10.339 8.605 11 9.5 11s1.5-.66 1.5-1.333h2c0 .672.605 1.333 1.5 1.333s1.5-.66 1.5-1.333h2c0 .672.605 1.333 1.5 1.333M17 12a3.6 3.6 0 003 .966V18H4v-5.034q.246.034.5.034c.958 0 1.854-.376 2.5-1 .646.624 1.542 1 2.5 1s1.854-.376 2.5-1c.646.624 1.542 1 2.5 1s1.854-.376 2.5-1"
    />
  );
export default SvgIconCake;
